import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { ILicense, ILicenseBulkDiscount } from '../../../Interface/license'
import { LgType } from '../../../services/prod/i18n.service'
import { CoreSettingsService } from '../../../settings/core-settings.service'

@Component({
  selector: 'bmcore-license-bulk-discount',
  templateUrl: './bmcore-license-bulk-discount.component.html',
  styleUrls: ['./bmcore-license-bulk-discount.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLicenseBulkDiscountComponent implements OnInit {
  @Input() trackLicense: ILicense
  @Input() licenseBulkDiscounts: ILicenseBulkDiscount[] = []
  @Input() lg: LgType
  @Input() isPopup = false

  BaseAssetsURL: string

  constructor(coreSettingsService: CoreSettingsService) {
    this.BaseAssetsURL = coreSettingsService.settings.urls.assetsURL
  }

  ngOnInit() {}
}
